import React from "react";
import Box from "../../assets/home/homeSphere.gif";
import twitter from "../../assets/contact/socials/twitter.png";
// import telegram from "../../assets/contact/socials/telegram.png";
// import medium from "../../assets/contact/socials/medium.png";
import linkedin from "../../assets/contact/socials/linkedin.png";
import Sphere from "../../components/Sphere";

const socialIcon = [
  {
    cover: twitter,
    href: "https://twitter.com/NverseLabs",
  },
  // {
  //   cover: medium,
  //   href: "/#",
  // },
  {
    cover: linkedin,
    href: "https://www.linkedin.com/company/nverselabs/",
  },
];
function Content() {
  return (
    <div className="flex flex-col md:flex-row justify-center items-center w-full h-full">
      <Sphere className="md:-left-[30%] md:top[0%] sm:-top-[8%] sm:h-[80%]" />
      <img
        src={Box}
        alt=""
        className="z-10 mix-blend-screen group-hover:grayscale-0 grayscale hover:grayscale-0 2xl:-ml-[11rem] lg:-ml-[5rem] sm:-mt-[5rem]"
      />
      <div className="lg:text-2xl sm:text-center sm:text-lg text-white text-left flex flex-col justify-start content-center 2xl:ml-[3rem] lg:ml-[2rem] sm:px-[3rem]">
        <div className="font-bold">YOUR WEB3 JOURNEY BEGINS HERE!</div>
        <div className="text-left mt-3 text-sm sm:text-center">
          Learn more about what we do at Nverse and get incubated! Reach out
          today!
        </div>
        <div className="items-center mt-6 flex flex-col md:flex-row">
          <a
            href="https://r9c7781s650.typeform.com/to/QHP2tHQJ"
            target="_blank"
            className="contactPage bg-gradient-to-b from-[#A1C7FF] to-[#7472D1] p-3 rounded-full weight-bold text-base text-white md:mr-6 z-[9999999]"
            rel="noreferrer"
          >
            CONTACT US
          </a>
          <div className="flex flex-row mt-6 justify-center items-center z-[9999999]">
            {socialIcon &&
              socialIcon.map((item, index) => (
                <div key={index} className="mr-1 -mt-[1rem]">
                  <a href={item.href}>
                    <img
                      src={item.cover}
                      alt="social-icon"
                      className="lg:m-[0.5rem]"
                    />
                  </a>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
}
export default Content;
